export default __webpack_public_path__ + "static/media/bandcamp.bd6f24ec.svg";